import useFeatureFlag from '@/components/hooks/useFeatureFlag';
import { CLIENT_FEATURE_FLAGS } from '@/constants';

function useIsHkRedesign() {
  const hkEnrollmentPAJDay1Flag = useFeatureFlag(
    CLIENT_FEATURE_FLAGS.GROWTH_HK_ENROLLMENT_PAJ_DAY1
  );

  const isHkRedesign = hkEnrollmentPAJDay1Flag?.value === 2;
  const isHkRedesignM2 = hkEnrollmentPAJDay1Flag?.value === 4;

  return {
    hkEnrollmentPAJDay1Flag,
    isHkRedesign,
    isHkRedesignM2,
  };
}

export default useIsHkRedesign;
